'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _form = require('../lib/form');

var _sanitizeHtml = require('../lib/sanitizeHtml');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _reactContenteditable = require('react-contenteditable');

var _reactContenteditable2 = _interopRequireDefault(_reactContenteditable);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputField = function (_React$Component) {
  _inherits(InputField, _React$Component);

  function InputField(props) {
    _classCallCheck(this, InputField);

    var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));

    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handlePaste = _this.handlePaste.bind(_this);
    _this.state = { value: props.value };
    return _this;
  }

  _createClass(InputField, [{
    key: 'getTag',
    value: function getTag() {
      switch (this.props.type) {
        case 'textarea':
          return 'textarea';
        case 'contenteditable':
          return _reactContenteditable2.default;
        default:
          return 'input';
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var _props = this.props,
          onChange = _props.onChange,
          type = _props.type;

      var value = (0, _form.isBoolean)(type) ? event.target.checked : event.target.value;

      this.setState({ value: value });

      return onChange && onChange(value);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var _props2 = this.props,
          onBlur = _props2.onBlur,
          type = _props2.type;

      var value = (0, _form.isBoolean)(type) ? event.target.checked : event.target.value;

      if (type === 'contenteditable') {
        return onBlur && onBlur((0, _sanitizeHtml2.default)(this.state.value));
      }

      return onBlur && onBlur(value);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var _props3 = this.props,
          onKeyDown = _props3.onKeyDown,
          type = _props3.type;


      onKeyDown && onKeyDown(event);

      if (type === 'contenteditable' && event.metaKey) {
        switch (event.key) {
          case 'u':
            return document.execCommand('underline', false);
          case 's':
            event.preventDefault();
            return document.execCommand('strikeThrough', false);
          default:
        }
      }
    }
  }, {
    key: 'handlePaste',
    value: function handlePaste(event) {
      var _this2 = this;

      var _props4 = this.props,
          onChange = _props4.onChange,
          type = _props4.type;


      if (type === 'contenteditable') {
        return setTimeout(function () {
          var value = (0, _sanitizeHtml2.default)(_this2.state.value);

          _this2.setState({ value: value });
          onChange && onChange(value);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          classNames = _props5.classNames,
          error = _props5.error,
          id = _props5.id,
          label = _props5.label,
          name = _props5.name,
          required = _props5.required,
          _props5$type = _props5.type,
          type = _props5$type === undefined ? 'text' : _props5$type,
          onBlur = _props5.onBlur,
          onChange = _props5.onChange,
          onKeyDown = _props5.onKeyDown,
          setRef = _props5.setRef,
          _props5$styles = _props5.styles,
          styles = _props5$styles === undefined ? {} : _props5$styles,
          status = _props5.status,
          validations = _props5.validations,
          value = _props5.value,
          props = _objectWithoutProperties(_props5, ['classNames', 'error', 'id', 'label', 'name', 'required', 'type', 'onBlur', 'onChange', 'onKeyDown', 'setRef', 'styles', 'status', 'validations', 'value']);

      var propsBlacklist = ['children', 'dirty', 'initial', 'invalid', 'styles', 'touched', 'validators'];
      var allowedProps = (0, _merge2.default)((0, _omit2.default)(props, propsBlacklist), type === 'contenteditable' ? { html: value } : { value: value });
      var Tag = this.getTag();
      var inputId = id || name;
      var labelId = 'label-' + inputId;

      var renderField = function renderField() {
        return _react2.default.createElement(Tag, _extends({
          ref: setRef,
          className: classNames.field,
          type: type,
          name: name,
          id: inputId,
          checked: (0, _form.isBoolean)(type) ? Boolean(value) : undefined,
          onChange: _this3.handleChange,
          onBlur: _this3.handleBlur,
          onKeyDown: _this3.handleKeyDown,
          onPaste: _this3.handlePaste,
          required: required,
          'aria-labelledby': labelId
        }, allowedProps));
      };

      var renderStatus = function renderStatus() {
        switch (status) {
          case 'fetching':
            return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'loading', spin: true, color: 'grey' });
          case 'fetched':
            return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'check', color: 'success' });
          case 'failed':
            return _react2.default.createElement(_icon2.default, { styles: styles.status, name: 'warning', color: 'danger' });
          default:
            return null;
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'c11n-input-field ' + classNames.root },
        label && _react2.default.createElement(
          _label2.default,
          {
            id: labelId,
            inputId: inputId,
            required: required,
            styles: {
              root: styles.label,
              required: styles.required
            }
          },
          label
        ),
        renderField(),
        status && renderStatus(),
        error && _react2.default.createElement(_inputValidations2.default, {
          styles: { root: styles.error },
          validations: validations
        })
      );
    }
  }]);

  return InputField;
}(_react2.default.Component);

InputField.propTypes = {
  /**
   * The label for the field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * Whether to display validation errors
   */
  error: _propTypes2.default.bool,

  /**
   * The name of the field
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * The current value
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]),

  /**
   * The change handler that will receive the updated value as it's only param
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The blur handler that will receive the updated value as it's only param
   */
  onBlur: _propTypes2.default.func,

  /**
   * The type of field
   */
  type: _propTypes2.default.oneOf(['checkbox', 'color', 'contenteditable', 'date', 'email', 'hidden', 'month', 'number', 'password', 'radio', 'range', 'search', 'tel', 'text', 'textarea', 'time', 'url', 'week']),

  /**
   * The placeholder for the field
   */
  placeholder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * The ID for the field
   */
  id: _propTypes2.default.string,

  /**
   * Mark the field as required and displays an asterisk next to the label
   */
  required: _propTypes2.default.bool,

  /**
   * Validation errors
   */
  validations: _propTypes2.default.array,

  styles: _propTypes2.default.object
};

InputField.defaultProps = {
  type: 'text'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputField);